import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=2e3936de&scoped=true&"
import script from "./Deliver.vue?vue&type=script&lang=js&"
export * from "./Deliver.vue?vue&type=script&lang=js&"
import style0 from "./Deliver.vue?vue&type=style&index=0&id=2e3936de&prod&scoped=true&lang=css&"
import style1 from "./Deliver.vue?vue&type=style&index=1&id=2e3936de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3936de",
  null
  
)

export default component.exports